export enum ChargeType {
  duty = 'duty',
  tax = 'tax',
}

export enum ChargeStatus {
  // Ожидает оплаты
  pending = 'pending',
  // Оплачено и скивтировано
  paid = 'paid',
  // Отменено
  canceled = 'canceled',
  // Ошибка
  error = 'error',
  // отправлено в ГИС ГМП
  sent = 'sent',
  // в процессе отмены
  canceling = 'canceling',
}

export const gisGmpStatuses = {
  [ChargeStatus.sent]: 'Отправлено в ГИС ГМП',
  [ChargeStatus.pending]: 'Ожидает оплаты',
  [ChargeStatus.paid]: 'Сквитировано',
  [ChargeStatus.canceled]: 'Аннулировано',
  [ChargeStatus.error]: 'Ошибка',
  [ChargeStatus.canceling]: 'В процессе аннулирования',
};
